import React, { useRef, useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import DateFnsUtils from "@date-io/date-fns";
import axios from "axios";
import { format, parseISO } from "date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

// PDF
import { jsPDF } from "jspdf";
import "jspdf-autotable";

const drawerWidth = 300;

const materialTheme = createTheme({
  // set default for now
});

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  appBar: {
    position: "fixed",
    backgroundColor: "yellow",
    color: "black",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  appBarBottom: {
    top: "auto",
    bottom: 0,
    padding: 10,
    background: "white",
    boxShadow: "none",
    [theme.breakpoints.up("sm")]: {},
  },
  grow: {
    flexGrow: 1,
  },
  leftLabel: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  rightLabel: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function FinalizeEditedInvoices(props) {
  const classes = useStyles();

  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [messageDialogMessage, setMessageDialogMessage] = useState("");
  const [isSavingTransaction, setIsSavingTransaction] = useState(false);
  const [isSavingTransactionSuccess, setIsSavingTransactionSuccess] = useState(false);

  function mainContent() {
    return (
      <React.Fragment>
        <div style={{ padding: ".25rem" }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={2} lg={2} className={classes.leftLabel}>
              Invoice Number*
            </Grid>
            <Grid item xs={12} sm={8} md={10} lg={10} className={classes.rightLabel}>
              <Typography variant="h6" gutterBottom>
                {props.selectedInvoices.auto_generated_invoice_number}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={2} lg={2} className={classes.leftLabel}>
              Invoice Date*
            </Grid>
            <Grid item xs={12} sm={8} md={10} lg={10} className={classes.rightLabel}>
              <Typography variant="h6" gutterBottom>
                {formatDateToYMD(props.selectedInvoices.invoice_date)}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={2} lg={2} className={classes.leftLabel}>
              Scheduled Delivery Date*
            </Grid>
            <Grid item xs={12} sm={8} md={10} lg={10} className={classes.rightLabel}>
              <Typography variant="h6" gutterBottom>
                {formatDateToYMD(props.selectedInvoices.invoice_date)}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={2} lg={2} className={classes.leftLabel}>
              Salesman:
            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10} className={classes.rightLabel}>
              <Typography variant="h6" gutterBottom>
                {props.selectedInvoices.salesman_first_name}{" "}
                {props.selectedInvoices.salesman_last_name}{" "}
                {props.selectedInvoices.salesman_middle_name}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={2} lg={2} className={classes.leftLabel}>
              Account Name:
            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10} className={classes.rightLabel}>
              <Typography variant="h6" gutterBottom>
                {props.selectedInvoices.account_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={2} lg={2} className={classes.leftLabel}>
              Number of lines:
            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10} className={classes.rightLabel}>
              <Typography variant="h6" gutterBottom>
                {props.invoicedItemCount}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={2} lg={2} className={classes.leftLabel}>
              Invoice Value:
            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10} className={classes.rightLabel}>
              <Typography variant="h6" gutterBottom>
                {Number(props.totalInvoicedAmount).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Grid>
          </Grid>
        </div>

        <AppBar position="fixed" className={classes.appBarBottom}>
          <Button
            variant="contained"
            color="primary"
            sx={{
              backgroundColor: "yellow",
              color: "black",
              "&:hover": {
                backgroundColor: "#CCCC00",
              },
            }}
            onClick={() => {
              updateInvoice();
            }}
          >
            Finalize invoice
          </Button>
        </AppBar>
      </React.Fragment>
    );
  }

  function progressDialog() {
    return (
      <Dialog fullWidth={true} maxWidth={"lg"} open={isSavingTransaction} onClose={() => {}}>
        <DialogContent>
          <DialogContentText>Saving invoice... Please wait...</DialogContentText>
          <LinearProgress color="secondary" />
        </DialogContent>
      </Dialog>
    );
  }
  function messageDialog() {
    return (
      <Dialog
        fullWidth={"sm"}
        maxWidth={"sm"}
        open={showMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {messageDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowMessageDialog(false);
              if (isSavingTransactionSuccess == true) {
                props.setOpenEditInvoiceDialog(false);
                props.setOpenFinalizeProductDialog(false);
                props.setOrderMenuAnchorElement(false);
                props.setLoadData(true);
              }
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      if (
        key == "invoiced_items" ||
        key == "total_invoiced_number_and_expiration_in_smallest_uom" ||
        key == "invoiced_lot_number_and_expirations"
      ) {
        object[key].forEach((order) => {
          formData.append(key, JSON.stringify(object[key]));
        });
      } else {
        formData.append(key, object[key]);
      }

      return formData;
    }, new FormData());

  function updateInvoice() {
    const updated_invoice = {
      invoice_items: props.invoicedProducts,
      auto_generated_invoice_number: props.selectedInvoices.auto_generated_invoice_number,
    };

    setIsSavingTransaction(true);

    const options = {
      method: "POST",
      url: "/TransactiInvoiceInformations/saveUpdateInvoices.json",
      data: updated_invoice,
    };

    axios(options)
      .then((res) => {
        const isSuccess = res.data.response.is_success;
        if (!isSuccess) {
          setIsSavingTransactionSuccess(false);
          setIsSavingTransaction(false);
          setMessageDialogMessage(res.data.response.message);
          setShowMessageDialog(true);

          return;
        }

        setIsSavingTransactionSuccess(true);
        setIsSavingTransaction(false);
        setMessageDialogMessage("Transaction save successfully.");
        setShowMessageDialog(true);
      })
      .catch((error) => {
        setIsSavingTransactionSuccess(false);
        setIsSavingTransaction(false);
        setMessageDialogMessage("Failed to save invoice. Please try again.");
        setShowMessageDialog(true);
      });
  }

  function formatDateToYMD(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-CA");
    // return date.toISOString().split("T")[0]; // Extracts YYYY-MM-DD
  }

  return (
    <>
      <Dialog fullScreen open={props.openFinalizeProductDialog} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={(e) => {
                e.stopPropagation();
                props.setOpenFinalizeProductDialog(false);
              }}
              aria-label="close"
              size="large"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Invoice information review
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.appBarSpacer}></div>
        {mainContent()}
      </Dialog>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          {messageDialog()}
          {progressDialog()}
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  );
}
